module.exports = __webpack_public_path__ + "media/images/map/big-star-2f99053430641629773ba09000ce018b.svg";